<template>
  <Transition name="fade" appear>
    <General side="back" />
  </Transition>
</template>

<script>
import General from "@/components/General.vue";

export default {
  components: { General },
};
</script>

<style>
</style>